export default __webpack_public_path__ + "static/1-8780f8ba0f9962cd6a80e21039eead4c.jpg";